var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 150,
    viewBox: "0 0 123 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5152 0H15.303C6.88636 0 0 6.75 0 15V135C0 143.25 6.88636 150 15.303 150H107.121C115.538 150 122.424 143.25 122.424 135V45L76.5152 0ZM84.1667 67.5H53.5606V75H76.5152C80.7235 75 84.1667 78.375 84.1667 82.5V105C84.1667 109.125 80.7235 112.5 76.5152 112.5H68.8636V120H53.5606V112.5H38.2576V97.5H68.8636V90H45.9091C41.7008 90 38.2576 86.625 38.2576 82.5V60C38.2576 55.875 41.7008 52.5 45.9091 52.5H53.5606V45H68.8636V52.5H84.1667V67.5Z",
    fill: "#0F4C81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanas);
export default __webpack_public_path__ + "static/media/Finanças.fc6e8916f867ed9bbcb14154fa4bc21b.svg";
export { ForwardRef as ReactComponent };